import { Platform } from '@angular/cdk/platform';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PwaConfirmComponent } from '@shared/dialogs/pwa-confirm/pwa-confirm.component';
import { DialogService } from './dialog.service';

@Injectable({
    providedIn: 'root'
})
export class PwaService {

    public modalPwaEvent: any;
    public modalPwaPlatform: 'IOS' | 'ANDROID' | undefined;

    constructor(
        private platform: Platform,
        private dialogService: DialogService,
        private dialog: MatDialog,
    ) { }

    public checkPlatform(): void {
        if (this.platform.ANDROID  && this.modalPwaEvent) {
            this.modalPwaPlatform = 'ANDROID';
            this.openPWADialog();
            return;
        }
        const isShowed = localStorage.getItem("shownDialog");
        const isInStandaloneMode = ('standalone' in window.navigator) && ((<any>window.navigator)['standalone']);
        if (this.platform.IOS && !isShowed && !isInStandaloneMode) {
            localStorage.setItem('shownDialog', "true");
            this.modalPwaPlatform = 'IOS';
            this.openPWADialog();
        }
    }

    public addToHomeScreen(): void {
        this.modalPwaEvent.prompt();
        this.modalPwaPlatform = undefined;
    }

    public closePwa(): void {
        this.modalPwaPlatform = undefined;
        this.dialog.closeAll();
    }

    private openPWADialog(): void {
        this.dialogService.show(PwaConfirmComponent, {
            hasBackdrop: true,
            width: '300px',
            panelClass: 'login-dialog-container'
        })
    }

}